// extracted by mini-css-extract-plugin
export default {"path":"style_path__cV591"};